import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

const TrackDeletionConfirmDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  trackName,
  isMarkedForDeletion = false 
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="track-deletion-dialog-title"
      aria-describedby="track-deletion-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="track-deletion-dialog-title">
        {isMarkedForDeletion ? 'Unmark Track for Deletion' : 'Mark Track for Deletion'}
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText id="track-deletion-dialog-description" component="div">
          {isMarkedForDeletion ? (
            <>
              <div style={{ marginBottom: '12px' }}>
                Are you sure you want to unmark this track for deletion? This will restore the track as "Unknown Instrument".
              </div>
              <div style={{ color: '#666', fontSize: '14px' }}>
                您确定要取消将该乐轨标记为应删除乐轨吗？这将把乐轨恢复为"未知乐器"。
              </div>
            </>
          ) : (
            <>
              <div style={{ marginBottom: '12px' }}>
                Are you sure you want to mark this track for deletion? It will remove all annotations you have added to this track.
              </div>
              <div style={{ color: '#666', fontSize: '14px' }}>
                您确定要将该乐轨标记为应删除乐轨吗？这将删除您在该乐轨上添加的所有标注。
              </div>
              {trackName && (
                <div style={{ marginTop: '16px', padding: '8px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                  <strong>Track:</strong> {trackName}
                </div>
              )}
            </>
          )}
        </DialogContentText>
      </DialogContent>
      
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button 
          onClick={handleCancel} 
          variant="outlined"
          style={{
            borderColor: '#999',
            color: '#555',
            borderRadius: '8px',
            fontWeight: '500',
            textTransform: 'none'
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained"
          style={{
            backgroundColor: isMarkedForDeletion ? '#22c55e' : '#ef4444',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '500',
            textTransform: 'none'
          }}
          autoFocus
        >
          {isMarkedForDeletion ? 'Unmark for Deletion' : 'Mark for Deletion'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrackDeletionConfirmDialog;
